import React from 'react';
import { useIntl } from 'react-intl-next';

import AdvancedSearchFooter from '../../advanced-search-footer';
import { messages } from '../messages';
import { QuickFindAdvancedSearchLink } from './quick-find-footer.styled';

export const SearchFooter = () => {
	const { formatMessage } = useIntl();
	return (
		<QuickFindAdvancedSearchLink>
			<AdvancedSearchFooter
				squareReturnIcon
				searchFooterLabel={formatMessage(messages.quick_find_footer_full_page_search_link)}
			/>
		</QuickFindAdvancedSearchLink>
	);
};
